import { ProductoService } from './../../../../services/producto.service';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import gql from 'graphql-tag';
import { ToastService } from 'ng-uikit-pro-standard';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { FormatoProductosService } from 'src/app/services/formato-productos.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalSeleccionarProductoComponent } from 'src/app/views/shared/modal-seleccionar-producto/modal-seleccionar-producto.component';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { debounceTime, filter } from 'rxjs/operators';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { TipoMovimientoService } from 'src/app/services/tipo-movimiento.service';
import { MovimientoStockService } from 'src/app/services/movimiento-stock.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import * as _ from 'lodash'
import { QueryResult } from 'src/app/shared/object/queryResult.model';

@Component({
  selector: 'app-modal-add-movimiento',
  templateUrl: './modal-add-movimiento.component.html',
  styleUrls: ['./modal-add-movimiento.component.scss']
})
export class ModalAddMovimientoComponent implements OnInit {

  // Outputs
  @Output() onSuccess: EventEmitter<any> = new EventEmitter<any>();

  // Modales
  @ViewChild('agregarMovimiento', { static: true }) modalAgregarMovimiento: ModalDirective
  @ViewChild(ModalSeleccionarProductoComponent, { static: true }) modalSeleccionarProducto: ModalSeleccionarProductoComponent

  @Input() optionsBodega: Array<any> = [];
  @Input() optionsTipDocumento: Array<any> = [];
  optionsTipoMovimiento: Array<any> = [];

  // Form
  formHeader: FormGroup
  formDetails: FormGroup


  // Data &  Tmp
  private rutEmpresa: Number
  private sucursalEmpresa: Number
  private rutUsuario: Number
  productoSeleccionado: any = null
  optionsFormato: Array<any> = [];
  listaMovimientos: Array<any> = []
  listaMovimientosAll: Array<any> = null
  paginationContext: PaginationContext = new PaginationContext()
  loading: boolean = false
  listaMovimientosResumen: any = null
  processing: boolean = false

  showBodegaEntrada: boolean = false
  showBodegaSalida: boolean = false

  // Utils
  private log: any
  OpTipoMov: number = null;

  constructor(
    private gqlclient: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private formatoProductoService: FormatoProductosService,
    private fb: FormBuilder,
    private clog: ConsoleService,
    private toastrService: ToastService,
    private messageRendererService: MessageRendererService,
    private datesService: DatesService,
    private formValidatorsService: FormValidatorsService,
    private tipoMovimientoServ: TipoMovimientoService,
    private movimientoStockService: MovimientoStockService,
    private productoService: ProductoService
  ) {
    this.log = this.clog.log('MODAL-ADD/EDIT-MOVIMIENTO')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo())
    this.rutUsuario = Number(this.accesolocalstorage.getRutUsuario())
    this.paginationContext.RecordsByPage = 10

    this.loadTipoMovimiento()

    this.createForms();
    this.formChangesSubscriptions()

    this.setDocElectronicoValidators()
    this.setBodegaValidators()
  }

  loadTipoMovimiento() {
    // Tipos Movimiento
    this.tipoMovimientoServ.GetTiposMovimiento(({ mensajes, respuesta }) => {
      const { registros } = respuesta
      // this.optionsTipoMovimiento = registros.map(tipo => ({ value: tipo.codigo, label: tipo.nombre, operacion: tipo.operacion }))
      this.optionsTipoMovimiento = registros.map(tipo => ({ value: tipo.codigo, label: tipo.nombre, ...tipo }))
      console.log("muestrame tipo mov ", this.optionsTipoMovimiento);
    })
  }

  createForms() {
    const now = this.datesService.CurrentDateToShortTimeString()
    this.log('now', now)
    this.formHeader = this.fb.group({
      fechaMovimiento: [now, [Validators.required]],
      tipoMovimiento: [null, [Validators.required]],
      ingresoDocElectronico: [false],
      tipoDocumento: [null],
      numeroDocumento: [''],
      bodegaEntrada: [null],
      bodegaSalida: [null],
      referencia: ['']
    });
    this.formDetails = this.fb.group({
      codigo: [null, [Validators.required, Validators.min(1)]],
      formato: [null, [Validators.required]],
      cantidad: [null, [Validators.required, Validators.min(1)]],
    });
    // this.formDetails = this.fb.group({
    //   codigo: [12035131, [Validators.required, Validators.min(1)]],
    //   formato: ["PALL", [Validators.required]],
    //   cantidad: [5, [Validators.required, Validators.min(1)]],
    // });
  }

  formChangesSubscriptions() {// código de producto

    this.formHeader.get("tipoMovimiento").valueChanges.subscribe((tipoMovimiento: number) => {
      if (tipoMovimiento === null || tipoMovimiento === undefined)
        return
      const tipoMovSeleccionado = this.optionsTipoMovimiento.filter(p => p.value === tipoMovimiento)[0]
      if (tipoMovSeleccionado) {
        const { operacion } = tipoMovSeleccionado
        this.showBodegaEntrada = operacion === 1 || operacion === 2
        this.showBodegaSalida = operacion === -1 || operacion === 2

        this.formHeader.get('bodegaSalida').setValidators([])
        if (this.showBodegaSalida) {
          this.formHeader.get('bodegaSalida').setValidators([Validators.required])
        }
        this.formHeader.get('bodegaSalida').updateValueAndValidity()

        this.OpTipoMov = operacion;
      }
    })

    this.formDetails.get("codigo").valueChanges
      .pipe(filter(Boolean), debounceTime(1000))
      .subscribe((codigo: string) => {
        this.log('codigo valueChanges', codigo)
        this.modalSeleccionarProducto.searchBySKU(codigo)
        this.modalSeleccionarProducto.clearLast()
      })
  }

  // get showBodegaEntrada() {
  //   const tipoMovimiento = this.formHeader.get('tipoMovimiento').value
  //   const operacion = this.optionsTipoMovimiento.filter(p => p.value === tipoMovimiento)[0]
  //   return operacion === 1 || operacion === 2
  // }

  // get showBodegaSalida() {
  //   const tipoMovimiento = this.formHeader.get('tipoMovimiento').value
  //   const operacion = this.optionsTipoMovimiento.filter(p => p.value === tipoMovimiento)[0]
  //   return operacion === -1 || operacion === 2
  // }

  setDocElectronicoValidators() {
    // this.log("setear validadores doc electrónico INIT")
    this.formHeader.get('ingresoDocElectronico').valueChanges.subscribe(ingresoDocElectronico => {
      // this.log("setear validadores doc electrónico 1", ingresoDocElectronico)
      this.formHeader.get('tipoDocumento').setValidators(null)
      this.formHeader.get('numeroDocumento').setValidators(null)
      if (ingresoDocElectronico) {
        // this.log("setear validadores doc electrónico ok")
        this.formHeader.get('tipoDocumento').setValidators([Validators.required])
        this.formHeader.get('numeroDocumento').setValidators([Validators.required])
      }
      else {
        // this.log("remover validadores doc electrónico")
        this.formHeader.get('tipoDocumento').setValidators(null)
        this.formHeader.get('numeroDocumento').setValidators(null)
      }
      this.formHeader.get('tipoDocumento').updateValueAndValidity()
      this.formHeader.get('numeroDocumento').updateValueAndValidity()
    })
  }

  setBodegaValidators() {
    // this.log("setear validadores bodega INIT")
    this.formHeader.get('tipoMovimiento').valueChanges.subscribe(tipoMovimiento => {
      // this.log("setear validadores bodega 1", tipoMovimiento)
      // get showBodegaEntrada() {
      //   return this.formHeader.get('tipoMovimiento').value === 1 || this.formHeader.get('tipoMovimiento').value === 2
      // }

      // this.log("remover validadores bodega")
      this.formHeader.get('bodegaEntrada').setValidators(null)
      this.formHeader.get('bodegaSalida').setValidators(null)
      if (tipoMovimiento === 1 || tipoMovimiento === 2) {
        // this.log("agregar para bodega entrada")
        this.formHeader.get('bodegaEntrada').setValidators([Validators.required])
      }
      if (tipoMovimiento === -1 || tipoMovimiento === 2) {
        // this.log("agregar para bodega salida")
        this.formHeader.get('bodegaSalida').setValidators([Validators.required])
      }

      this.formHeader.get('bodegaEntrada').updateValueAndValidity()
      this.formHeader.get('bodegaSalida').updateValueAndValidity()
      // get showBodegaSalida() {
      //   return this.formHeader.get('tipoMovimiento').value === -1 || this.formHeader.get('tipoMovimiento').value === 2
      // }
    })
  }

  /********* SHOW/HIDE *********/
  show() {
    this.reset()
    this.modalAgregarMovimiento.show();
  }

  hide() {
    this.reset()
    this.modalAgregarMovimiento.hide();
  }

  reset() {
    this.formHeader.get('tipoMovimiento').enable()
    this.formHeader.get('bodegaSalida').enable()
    this.formHeader.get('bodegaEntrada').enable()
    this.resetFormHeader()
    this.resetFormDetails()
    this.resetListaMovimientos()
    this.loading = false
  }

  resetFormHeader() {
    this.formHeader.reset()
    this.formHeader.markAsPristine()
    this.formHeader.markAsUntouched()

    const now = this.datesService.CurrentDateToShortTimeString()
    this.formHeader.get("fechaMovimiento").setValue(now)
    this.formHeader.get("tipoMovimiento").setValue(null)
    this.formHeader.get("ingresoDocElectronico").setValue(false)
    this.formHeader.get("tipoDocumento").setValue(null)
    this.formHeader.get("numeroDocumento").setValue('')
    this.formHeader.get("bodegaEntrada").setValue(null)
    this.formHeader.get("bodegaSalida").setValue(null)
    this.formHeader.get("referencia").setValue('')
  }

  resetFormDetails() {
    this.formDetails.reset()
    this.formDetails.markAsPristine()
    this.formDetails.markAsUntouched()

    this.formDetails.get("codigo").setValue(null)
    this.formDetails.get("formato").setValue(null)
    this.formDetails.get("cantidad").setValue(null)

    this.productoSeleccionado = null
    this.optionsFormato = []
  }

  resetListaMovimientos() {
    this.listaMovimientos = []
    this.listaMovimientosAll = []
    this.listaMovimientosResumen = null
  }
  /********* SHOW/HIDE *********/


  /********* MODALS *********/
  abrirModalSeleccionarProducto() {

    //Validar que existe tipo mov y bodega;

    const tipoMovimiento = this.ObtenerTipoMovimiento()
    if (!tipoMovimiento) {
      this.toastrService.warning('Seleccione tipo de movimiento')
      return
    }

    const tipoMovSeleccionado = this.optionsTipoMovimiento.filter(p => p.value === tipoMovimiento)[0]
    const { operacion } = tipoMovSeleccionado    // (-1 y 2)
    this.log('operación', operacion)

    if (operacion === 1 || operacion === 2) { // Entrada y // Traslado
      const bodegaEntrada = this.ObtenerBodegaEntrada()
      if (!bodegaEntrada) {
        this.toastrService.warning('Seleccione bodega entrada')
        return
      }
    }

    const bodegaSalida = this.ObtenerBodegaSalida()
    if (operacion === -1 || operacion === 2) { // Entrada y // Traslado
      if (!bodegaSalida) {
        this.toastrService.warning('Seleccione bodega salida')
        return
      }
    }

    this.modalSeleccionarProducto.show({
      showInforAdicionar: true,
      cleanData: true
    })

  }

  getProducts({ inputParams: modalInputParams, callback }) {
    //ENVIAR PARAMETRO BODEGA - Por defecto BODEGA PRINCIPAL
    let bodEntrada: any;
    let bodSalida: any;
    bodEntrada = this.formHeader.get('bodegaEntrada').value;
    bodSalida = this.formHeader.get('bodegaSalida').value
    // Entrada 1 - Salida -1 - Traslado 2
    switch (this.OpTipoMov) {
      case -1:
        bodEntrada = this.formHeader.get('bodegaEntrada').setValue(null);
        bodSalida = this.formHeader.get('bodegaSalida').value
        break;
      case 1:
        bodEntrada = this.formHeader.get('bodegaEntrada').value;
        bodSalida = this.formHeader.get('bodegaSalida').setValue(null);
        break;
      case 2:

        break;
      default:
        bodEntrada = this.formHeader.get('bodegaEntrada').setValue(1);
        break;
    }

    const self = this

    this.log(modalInputParams)
    const inputParams = {
      empresa_rut: modalInputParams.empresa_rut,
      sucursal_codigo: modalInputParams.sucursal_codigo,
      bodega_codigo: this.OpTipoMov == 1 ? bodEntrada : bodSalida,
      sku: modalInputParams.sku,
      descripcion: modalInputParams.descripcion,
      tipobusquedad_afecto_exento: modalInputParams.tipobusquedad_afecto_exento,
      familia: modalInputParams.familia,
      rubro: modalInputParams.rubro,
      //unidad_negocio_codigo: null,
      paginaActual: modalInputParams.paginaActual,
      cantidadRegistrosPorPagina: modalInputParams.cantidadRegistrosPorPagina
    }

    this.log('inputParams', JSON.stringify(inputParams))

    this.productoService.obtenerSegunFiltroProductosConSaldos(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      if (!respuesta) {
        callback(new QueryResult(null, 0, 0, 0))
        return
      }
      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
      callback(new QueryResult(registros, paginaActual, totalPaginas, totalRegistros))
    });

  }

  onProductoSeleccionado({ data: _productoSeleccionado, origen }) {
    this.log(origen, _productoSeleccionado)
    this.productoSeleccionado = _productoSeleccionado
    this.formDetails.get('codigo').setValue(_productoSeleccionado.sku)
    this.formDetails.get('formato').setValue(null)
    // this.formDetails.get('cantidad').setValue(0)

    // Fill combo
    this.formatoProductoService.GetFormatosByCodigo(
      this.rutEmpresa,
      this.productoSeleccionado.codigo,
      ({ mensajes, respuesta }) => {
        this.log('callback', respuesta.registros)
        this.optionsFormato = respuesta.registros.map(formato => ({ value: formato.formato_codigo, label: formato.formato_nombre, precio_costo: formato.precio_costo, ...formato }))
        this.formValidatorsService.selectDefaultFormatoProducto(this.formDetails.get('formato'), this.optionsFormato)
      }
    )
  }

  onProductoNoEncontrado() {
    this.productoSeleccionado = null
    this.optionsFormato = []
    this.formDetails.get("formato").setValue(null)
  }
  /********* MODALS *********/

  /********* OPERATIONS *********/

  // get showBodegaEntrada() {
  //   const tipoMovimiento = this.formHeader.get('tipoMovimiento').value
  //   const operacion = this.optionsTipoMovimiento.filter(p => p.value === tipoMovimiento)[0]
  //   return operacion === 1 || operacion === 2
  // }

  // get showBodegaSalida() {
  //   const tipoMovimiento = this.formHeader.get('tipoMovimiento').value
  //   const operacion = this.optionsTipoMovimiento.filter(p => p.value === tipoMovimiento)[0]
  //   return operacion === -1 || operacion === 2
  // }

  get isDocElectronico() {
    return this.formHeader.get("ingresoDocElectronico").value
  }

  validarExistenciaYAgregar() {
    const formatoSeleccionado = this.formDetails.get('formato').value
    // Validar si ya está en la lista
    const productosEnLista = this.listaMovimientosAll ? this.listaMovimientosAll.filter(p => p.sku === this.productoSeleccionado.sku && p.formato_codigo === formatoSeleccionado) : []
    if (productosEnLista.length > 0) {
      this.toastrService.warning('Producto ya se encuentra en la lista')
      return
    }

    this.formValidatorsService.validateAllFormFields(this.formDetails);
    if (!this.formDetails.valid) {
      this.toastrService.warning('Favor complete los datos requeridos');
      return
    }

    const tipoMovimiento = this.ObtenerTipoMovimiento()
    if (!tipoMovimiento) {
      this.toastrService.warning('Seleccione tipo de movimiento')
      return
    }

    const tipoMovSeleccionado = this.optionsTipoMovimiento.filter(p => p.value === tipoMovimiento)[0]
    const { operacion } = tipoMovSeleccionado    // (-1 y 2)
    this.log('operación', operacion)

    // if (tipoMovimiento === 1 || tipoMovimiento === 2) {
    //   // this.log("agregar para bodega entrada")
    //   this.formHeader.get('bodegaEntrada').setValidators([Validators.required])
    // }
    // if (tipoMovimiento === -1 || tipoMovimiento === 2) {
    //   // this.log("agregar para bodega salida")
    //   this.formHeader.get('bodegaSalida').setValidators([Validators.required])
    // }


    if (operacion === 1 || operacion === 2) { // Entrada y // Traslado
      const bodegaEntrada = this.ObtenerBodegaEntrada()
      if (!bodegaEntrada) {
        this.toastrService.warning('Seleccione bodega entrada')
        return
      }
    }

    // if (operacion === 1) { // Entrada
    //   this.agregar()
    //   return
    // }

    const bodegaSalida = this.ObtenerBodegaSalida()
    if (operacion === -1 || operacion === 2) { // Entrada y // Traslado
      if (!bodegaSalida) {
        this.toastrService.warning('Seleccione bodega salida')
        return
      }
    }

    // const inputParams = {
    //   entidad: {
    //     rut_emisor: Number(this.rutEmpresa),
    //     sucursal_codigo: Number(this.sucursalEmpresa),
    //     fecha_movimiento: this.datesService.CurrentDateToShortTimeString(),
    //     // sku: this.formDetails.get('codigo').value,
    //     sku: this.productoSeleccionado.sku,
    //   },
    //   paginaActual: 1,
    //   cantidadRegistrosPorPagina: -1
    // }

    // const newMovimiento: any = {
    //   sku: this.productoSeleccionado.sku,
    //   codigo: this.productoSeleccionado.codigo,
    //   descripcion: this.productoSeleccionado.descripcion,
    //   formato: formatoSeleccionado,
    //   formatoGlosa: this.optionsFormato.filter(opt => opt.value === formatoSeleccionado)[0].label,
    //   cantidad: Number(this.formDetails.get('cantidad').value),
    //   // TODO: No viene el valor. Vendrá desde el formato precio_costo. De momento viene en 0, pero se agregará un vez implementado en back
    //   precio_costo: this.optionsFormato.filter(opt => opt.value === formatoSeleccionado)[0].precio_costo,
    //   costoTotal: 0,
    //   checked: false,
    //   index: this.listaMovimientos.length + 1
    // }

    if (this.listaMovimientos)
      this.listaMovimientos.forEach(mov => {
        delete mov.__typename
      })
    if (this.listaMovimientosAll)
      this.listaMovimientosAll.forEach(mov => {
        delete mov.__typename
      })

    const bodega_codigo = operacion === 1 ? this.ObtenerBodegaEntrada() : bodegaSalida

    const lista = this.listaMovimientosAll ? _.cloneDeep(this.listaMovimientosAll) : []
    lista.forEach(p => {
      delete p.__typename
      delete p.additionalInfo
    })
    const inputParams = {
      entidad: {
        rut_emisor: Number(this.rutEmpresa),
        rut_empresa: Number(this.rutEmpresa),
        sucursal_codigo: Number(this.sucursalEmpresa),
        bodega_codigo,
        producto_codigo: this.productoSeleccionado.codigo,
        sku: this.productoSeleccionado.sku,
        producto_descripcion: this.productoSeleccionado.descripcion,
        formato_codigo: formatoSeleccionado,
        formato_nombre: this.optionsFormato.filter(opt => opt.value === formatoSeleccionado)[0].label,
        cantidad: Number(this.formDetails.get('cantidad').value)
      },
      operacion,
      lista
    }

    this.log('inputParams', JSON.stringify(inputParams))

    this.loading = true

    this.movimientoStockService.validarStockYAgregar(inputParams, ({ mensajes, respuesta }) => {
      const ok = mensajes.filter(m => m.tipo === "ERROR").length === 0
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        this.loading = false
        return
      }

      // const { registros } = respuesta

      // const bodegaSalida = this.formHeader.get('bodegaSalida').value
      // const { formato, cantidad } = this.formDetails.value
      // this.log('bodega salida', bodegaSalida, 'formato', formato)

      // const listaStocks = registros.filter(p => p.bodega_codigo === bodegaSalida && p.formato_codigo === formato)
      // this.log('listaStocks', listaStocks)

      // if (!listaStocks || listaStocks.length === 0) {
      //   this.toastrService.error('No se pudo obtener información de stock para el producto y formato seleccionados.')
      //   return
      // }

      // const { saldo } = listaStocks[0]
      // this.log('saldo', saldo, 'cantidad', cantidad)
      // if (saldo < cantidad) {
      //   this.toastrService.error(`Cantidad ingresada supera la cantidad disponible en bodega (${saldo})`)
      //   return
      // }

      // this.agregar()

      // Limpiar lista
      this.listaMovimientos = null
      this.listaMovimientosAll = null
      this.listaMovimientosResumen = null

      // agregar a lista
      this.listaMovimientosAll = respuesta

      this.paginationContext.RecordsCount = this.listaMovimientosAll.length //totalRegistros
      this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage) //totalPaginas
      this.paginationContext.CurrentPage = 1

      this.listaMovimientosAll.forEach((mov, index) => {
        mov.additionalInfo = {}
        mov.additionalInfo.index = index
        mov.additionalInfo.checked = false
        mov.additionalInfo.costoTotal = mov.cantidad * mov.precio_costo
      })

      this.formHeader.get('tipoMovimiento').disable()
      this.formHeader.get('bodegaSalida').disable()
      this.formHeader.get('bodegaEntrada').disable()

      this.showPage(this.paginationContext.CurrentPage)
      this.loading = false

      this.toastrService.success('Registro agregado')

      this.calcularTotales()
      this.resetFormDetails()
    })
  }

  showPage(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber
    const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage
    this.listaMovimientos = _.slice(this.listaMovimientosAll, start, start + this.paginationContext.RecordsByPage)
  }

  onPageChange(context: PaginationContext) {
    this.showPage(context.RequestedPage)
  }

  ObtenerTipoMovimiento() {
    return this.ObtenerValorFormHeader('tipoMovimiento')
  }

  ObtenerBodegaSalida() {
    return this.ObtenerValorFormHeader('bodegaSalida')
  }

  ObtenerBodegaEntrada() {
    return this.ObtenerValorFormHeader('bodegaEntrada')
  }

  ObtenerValorFormHeader(formControlName: string) {
    // Activar y desactivar según corresponda para obtener el valor. (desactivado el valor es null, por eso se activa antes de obtener su valor)
    const formControlState = this.formHeader.get(formControlName).enabled
    this.formHeader.get(formControlName).enable()
    const formControlValue = this.formHeader.get(formControlName).value
    if (formControlState)
      this.formHeader.get(formControlName).enable()
    else
      this.formHeader.get(formControlName).disable()
    return formControlValue
  }

  // agregar() {
  //   this.log('this.optionsTipoMovimiento', this.optionsTipoMovimiento)
  //   this.log(this.formDetails.value)
  //   this.log(this.productoSeleccionado)
  //   this.validateAllFormFields(this.formDetails);
  //   if (!this.formDetails.valid) {
  //     this.toastrService.warning('Favor complete los datos requeridos');
  //     return
  //   }

  //   const formatoSeleccionado = this.formDetails.get('formato').value

  //   // nuevo item
  //   const newMovimiento: any = {
  //     sku: this.productoSeleccionado.sku,
  //     codigo: this.productoSeleccionado.codigo,
  //     descripcion: this.productoSeleccionado.descripcion,
  //     formato: formatoSeleccionado,
  //     formatoGlosa: this.optionsFormato.filter(opt => opt.value === formatoSeleccionado)[0].label,
  //     cantidad: Number(this.formDetails.get('cantidad').value),
  //     // TODO: No viene el valor. Vendrá desde el formato precio_costo. De momento viene en 0, pero se agregará un vez implementado en back
  //     precio_costo: this.optionsFormato.filter(opt => opt.value === formatoSeleccionado)[0].precio_costo,
  //     costoTotal: 0,
  //     checked: false,
  //     index: this.listaMovimientos.length + 1
  //   }
  //   newMovimiento.costoTotal = newMovimiento.precio_costo * newMovimiento.cantidad
  //   this.log('newMovimiento', newMovimiento)

  //   // agregar a lista
  //   this.listaMovimientos.push(newMovimiento)

  //   this.formHeader.get('tipoMovimiento').disable()
  //   this.formHeader.get('bodegaSalida').disable()
  //   this.formHeader.get('bodegaEntrada').disable()


  //   this.calcularTotales()
  //   this.toastrService.success('Registro agregado')

  //   this.resetFormDetails()
  // }

  calcularTotales() {
    this.listaMovimientosResumen = {}
    this.listaMovimientosResumen.cantidad = this.listaMovimientosAll.reduce((prev, cur) => prev + cur.cantidad, 0);
    this.listaMovimientosResumen.subtotal = this.listaMovimientosAll.reduce((prev, cur) => prev + cur.precio_costo, 0);
    this.listaMovimientosResumen.total = this.listaMovimientosAll.reduce((prev, cur) => prev + cur.additionalInfo.costoTotal, 0);
    this.log(this.listaMovimientosResumen)
  }

  checkAllChange({ checked }) {
    this.log(checked)
    this.listaMovimientosAll.forEach(mov => { mov.additionalInfo.checked = checked })
    this.listaMovimientos.forEach(mov => { mov.additionalInfo.checked = checked })
  }

  checkMovimiento({ index }, { checked }) {
    // const selected = this.listaMovimientos.filter(p => p.index === movimiento.index)[0]
    // selected.checked = !selected.checked
    // this.log(this.listaMovimientos)
    const _indexAll = this.listaMovimientosAll.findIndex(p => p.additionalInfo.index === index)
    this.listaMovimientosAll[_indexAll].additionalInfo.checked = checked

    const _indexPage = this.listaMovimientos.findIndex(p => p.additionalInfo.index === index)
    this.listaMovimientos[_indexPage].additionalInfo.checked = checked
  }

  eliminarMovimiento(mov) {
    this.listaMovimientos = this.listaMovimientos.filter(_mov => _mov.additionalInfo.index !== mov.additionalInfo.index)
    this.listaMovimientosAll = this.listaMovimientosAll.filter(_mov => _mov.additionalInfo.index !== mov.additionalInfo.index)
    this.showPage(1)
    this.calcularTotales()
  }

  eliminarSeleccionados() {
    this.listaMovimientos = this.listaMovimientos.filter(_mov => !_mov.additionalInfo.checked)
    this.listaMovimientosAll = this.listaMovimientosAll.filter(_mov => !_mov.additionalInfo.checked)
    this.calcularTotales()
    this.showPage(1)
  }

  print() {
    window.print();
  }

  guardar() {
    this.formValidatorsService.validateAllFormFields(this.formHeader);
    if (!this.formHeader.valid) {
      this.toastrService.warning('Favor complete los datos requeridos');
      return
    }

    const tipoMovimiento = this.ObtenerTipoMovimiento()

    // const codigo = Number(tipoMovimiento)
    const tipoMovSeleccionado = this.optionsTipoMovimiento.filter(p => p.value === tipoMovimiento)[0]
    const { operacion } = tipoMovSeleccionado
    const ingresoDocElectronico = this.formHeader.get('ingresoDocElectronico').value

    const movimientoStock = {
      operacion,
      entidad: []
    }
    let bodegaEntradaSucursal = null
    // if (this.formHeader.get('bodegaEntrada').value) {
    //   let bodegaEntradaLista = this.optionsBodega.filter(p => p.value === Number(this.formHeader.get('bodegaEntrada').value))
    //   if (bodegaEntradaLista && bodegaEntradaLista.length > 0)
    //   bodegaEntradaSucursal = bodegaEntradaLista[0].sucursal_codigo
    // }
    const bodegaEntrada = this.ObtenerBodegaEntrada()
    if (bodegaEntrada) {
      let bodegaEntradaLista = this.optionsBodega.filter(p => p.value === Number(bodegaEntrada))
      if (bodegaEntradaLista && bodegaEntradaLista.length > 0)
        bodegaEntradaSucursal = bodegaEntradaLista[0].sucursal_codigo
    }

    let bodegaSalidaSucursal = null
    // if (this.formHeader.get('bodegaSalida').value) {
    //   let bodegaSalidaLista = this.optionsBodega.filter(p => p.value === Number(this.formHeader.get('bodegaSalida').value))
    //   if (bodegaSalidaLista && bodegaSalidaLista.length > 0)
    //     bodegaSalidaSucursal = bodegaSalidaLista[0].sucursal_codigo
    // }
    const bodegaSalida = this.ObtenerBodegaSalida()
    if (bodegaSalida) {
      let bodegaSalidaLista = this.optionsBodega.filter(p => p.value === Number(bodegaSalida))
      if (bodegaSalidaLista && bodegaSalidaLista.length > 0)
        bodegaSalidaSucursal = bodegaSalidaLista[0].sucursal_codigo
    }

    const movimientos = _.cloneDeep(this.listaMovimientosAll)
    movimientos.forEach(mov => {
      delete mov.__typename
      delete mov.additionalInfo
    });

    movimientoStock.entidad = movimientos.map(producto => (
      {
        // codigo: operacion,
        es_venta: false,
        es_compra: false,
        rut_emisor: this.rutEmpresa,
        rut_empresa: this.rutEmpresa,
        rut_usuario: this.rutUsuario,
        folio: 0,
        tipo_dte_codigo: ingresoDocElectronico ? this.formHeader.get('tipoDocumento').value : 0,  // Tipo de Documento, si no está va en 0
        fecha_movimiento: this.datesService.mergeFechaSeleccionadaConHoraActual(
          this.formHeader.get('fechaMovimiento').value
        ),
        producto_codigo: producto.producto_codigo, // codigo producto seleccionado
        formato_codigo: producto.formato_codigo, // codigo de formato
        referencia: this.formHeader.get("referencia").value,
        operacion: operacion,
        cantidad: producto.cantidad, // Campo cantidad
        // dia_movimiento: 20201126, // fechaMov.ToString("yyyyMMdd") // Los hará Pedro
        // mes_movimiento: 202011, // Los hará Pedro
        tipo_movimiento_codigo: tipoMovimiento, // campo *codigo* de tipo de movimiento
        // bodega_sucursal_codigo_ingreso: this.showBodegaEntrada ? this.optionsBodega.filter(p => p.value === Number(this.formHeader.get('bodegaEntrada').value))[0].sucursal_codigo : 0, // *sucursal* bodega ingreso
        bodega_sucursal_codigo_ingreso: this.showBodegaEntrada ? bodegaEntradaSucursal : 0, // *sucursal* bodega ingreso
        bodega_codigo_ingreso: this.showBodegaEntrada ? Number(bodegaEntrada) : 0, // *codigo* bodega ingreso
        // bodega_sucursal_codigo_salida: this.showBodegaSalida ? this.optionsBodega.filter(p => p.value === Number(this.formHeader.get('bodegaSalida').value))[0].sucursal_codigo : 0, // *sucursal* bodega salida
        bodega_sucursal_codigo_salida: this.showBodegaSalida ? bodegaSalidaSucursal : 0, // *sucursal* bodega salida
        bodega_codigo_salida: this.showBodegaSalida ? Number(bodegaSalida) : 0, // *codigo* bodega salida
        // periodo_anno_mes: 202011, // Lo hará Pedro
        sucursal_codigo: this.sucursalEmpresa
      }))

    // this.log('movimientoStock', movimientoStock)
    this.log('inputParams....', JSON.stringify(movimientoStock))
    this.processing = true

    // return

    const self = this
    this.gqlclient.mutate(
      {

        mutation: gql`
        mutation($entidad:[movimiento_stockInputType], $operacion:Int){
          movimiento_stock{
            validarMovimiento(entidad:$entidad, operacion:$operacion){
              mensajes{
                tipo
                texto
                codigo
                contexto
              }
              respuesta{
                codigo
                es_venta
                es_compra
                rut_emisor
                rut_usuario
                folio
                tipo_dte_codigo
                fecha_movimiento
                producto_codigo
                formato_codigo
                referencia
                operacion
                cantidad
                dia_movimiento
                mes_movimiento
                tipo_movimiento_codigo
                bodega_sucursal_codigo_ingreso
                bodega_codigo_ingreso
                bodega_sucursal_codigo_salida
                bodega_codigo_salida
                periodo_anno_mes
                sucursal_codigo
              }
            }
          }
        }
        `,
        variables: movimientoStock,
      },
      function (_respuesta) {
        const { mensajes, respuesta } = _respuesta.data.movimiento_stock.validarMovimiento
        const ok = mensajes.filter(m => m.tipo === "ERROR").length === 0
        if (!ok) {
          self.messageRendererService.showErrors(mensajes)
          self.processing = false
          return
        }
        else {
          self.toastrService.success('Movimiento de inventario guardado')
          self.hide()
          self.reset()
          self.onSuccess.emit()
          self.processing = false
          return
        }
      }
    );
  }
  /********* OPERATIONS *********/

}
